import { Authentication } from 'hooks/useAuthentication'
import React from 'react'

export const AuthContext = React.createContext<Authentication>(null as any)
